import './index.scss'
import {
  Toggle,
  ToggleSmallSkeleton,
  ToggleSmall,
  ToggleSkeleton
} from 'carbon-components-react'
Toggle.ToggleSmallSkeleton = ToggleSmallSkeleton
Toggle.ToggleSmall = ToggleSmall
Toggle.ToggleSkeleton = ToggleSkeleton
export {
  Toggle,
  ToggleSmallSkeleton,
  ToggleSmall,
  ToggleSkeleton,
  Toggle as default
}
